import React from 'react'

const DeviceContext = React.createContext({});


class DeviceProvider extends React.Component {
    constructor(props) {
        super(props);
    }


    render() {
        return (
            <DeviceContext.Provider value={{device: this.props.device}}>
                {this.props.children}
            </DeviceContext.Provider>
        )
    }

}


const DeviceConsumer = DeviceContext.Consumer

export default DeviceProvider

export { DeviceConsumer }



// WEBPACK FOOTER //
// components/DeviceContext.js